import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../services/contexts/AuthContext';
import TenantPatientSidebar from './components/TenantPatientSidebar';
import TenantPatientDashboard from './pages/TenantPatientDashboard';
import MyVitalSigns from './pages/MyVitalSigns';
import { LogOut } from 'lucide-react';

const TenantPatientApp = () => {
  const { user, logout } = useAuth();
  const [activeView, setActiveView] = useState('dashboard');

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Tenant Patient Sidebar */}
      <TenantPatientSidebar activeView={activeView} setActiveView={setActiveView} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Navigation Bar */}
        <header className="bg-white shadow-sm border-b border-va-neutral-200">
          <div className="flex items-center justify-between px-6 py-4">
            <div>
              <h1 className="text-2xl font-bold text-va-neutral-900">My Health Portal</h1>
              <p className="text-sm text-va-neutral-600">Your personal health dashboard and vital signs tracking</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-va-neutral-900">{user?.name}</p>
                <p className="text-xs text-va-neutral-500">Patient</p>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-sm text-va-neutral-700 hover:text-va-neutral-900 hover:bg-va-neutral-100 rounded-lg transition-colors"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </header>

        {/* Content Area */}
        <main className="flex-1 overflow-auto p-6">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TenantPatientDashboard />} />
            <Route path="vitals" element={<MyVitalSigns />} />
            <Route path="recordings" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Recording History</h2>
                <p className="text-gray-600">Detailed recording session history coming soon...</p>
              </div>
            } />
            <Route path="health-insights" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Health Insights</h2>
                <p className="text-gray-600">AI-powered health insights and recommendations coming soon...</p>
              </div>
            } />
            <Route path="profile" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">My Profile</h2>
                <p className="text-gray-600">Profile management coming soon...</p>
              </div>
            } />
            <Route path="appointments" element={
              <div className="text-center py-12">
                <h2 className="text-xl font-bold text-gray-900 mb-4">My Appointments</h2>
                <p className="text-gray-600">Appointment scheduling and management coming soon...</p>
              </div>
            } />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default TenantPatientApp;